// TopWallet — i18n unified (cards + detail pages content) · ES/EN/SK.
// Used by TopWalletSection.jsx (hub) and TopWalletSeccionPage.jsx (detail).

export const I18N_TW = {
  cards: [
    {
      id: "carteras",
      numero: "01",
      icono: "🗂️",
      badge: { es: "CARTERAS", en: "WALLETS", sk: "PEŇAŽENKY", de: "WALLETS", "zh-CN": "钱包" },
      titulo: { es: "Carteras Digitales", en: "Digital Wallets", sk: "Digitálne Peňaženky", de: "Digitale Wallets", "zh-CN": "数字钱包" },
      descripcion: {
        es: "Aprende qué son las wallets, cómo crearlas y proteger tus claves privadas. Compara las 35 mejores del mercado.",
        en: "Learn what wallets are, how to create them and protect your private keys. Compare the 35 best on the market.",
        sk: "Zisti, čo sú peňaženky, ako ich vytvoriť a chrániť kľúče. Porovnaj 35 najlepších na trhu.", de: "Erfahre, was Wallets sind, wie du sie erstellst und deine Private Keys schützt. Vergleiche die 35 besten auf dem Markt.", "zh-CN": "了解什么是钱包、如何创建和保护你的私钥。对比市场上最好的 35 款钱包。",
      },
      boton: { es: "Explorar Carteras Digitales →", en: "Explore Digital Wallets →", sk: "Preskúmať Peňaženky →", de: "Digitale Wallets erkunden →", "zh-CN": "探索数字钱包 →" },
      href: "/topwallet/carteras",
    },
    {
      id: "redes",
      numero: "02",
      icono: "🕸️",
      badge: { es: "BLOCKCHAIN", en: "BLOCKCHAIN", sk: "BLOCKCHAIN", de: "BLOCKCHAIN", "zh-CN": "区块链" },
      titulo: { es: "Redes Blockchain", en: "Blockchain Networks", sk: "Blockchain Siete", de: "Blockchain-Netzwerke", "zh-CN": "区块链网络" },
      descripcion: {
        es: "Descubre cómo funcionan las redes descentralizadas, nodos y consenso. Bitcoin, Ethereum, Solana explicados desde cero.",
        en: "Discover how decentralized networks, nodes and consensus work. Bitcoin, Ethereum, Solana explained from scratch.",
        sk: "Objav, ako fungujú decentralizované siete. Bitcoin, Ethereum, Solana vysvetlené od základov.", de: "Entdecke, wie dezentrale Netzwerke, Nodes und Konsens funktionieren. Bitcoin, Ethereum, Solana von Grund auf erklärt.", "zh-CN": "了解去中心化网络、节点和共识机制的运作方式。从零开始讲解比特币、以太坊、Solana。",
      },
      boton: { es: "Explorar Redes Blockchain →", en: "Explore Blockchain Networks →", sk: "Preskúmať Blockchain Siete →", de: "Blockchain-Netzwerke erkunden →", "zh-CN": "探索区块链网络 →" },
      href: "/topwallet/redes",
    },
    {
      id: "seguridad",
      numero: "03",
      icono: "🔐",
      badge: { es: "SEGURIDAD", en: "SECURITY", sk: "BEZPEČNOSŤ", de: "SICHERHEIT", "zh-CN": "安全" },
      titulo: { es: "Seguridad Digital", en: "Digital Security", sk: "Digitálna Bezpečnosť", de: "Digitale Sicherheit", "zh-CN": "数字安全" },
      descripcion: {
        es: "Frases semilla, hardware wallets y buenas prácticas anti-estafa. Protege tus activos como un profesional.",
        en: "Seed phrases, hardware wallets and anti-scam best practices. Protect your assets like a professional.",
        sk: "Seed frázy, hardvérové peňaženky a postupy proti podvodom. Chráňte aktíva ako profesionál.", de: "Seed Phrases, Hardware Wallets und Best Practices gegen Betrug. Schütze deine Assets wie ein Profi.", "zh-CN": "助记词、硬件钱包和防诈骗最佳实践。像专业人士一样保护你的资产。",
      },
      boton: { es: "Explorar Seguridad Digital →", en: "Explore Digital Security →", sk: "Preskúmať Digitálnu Bezpečnosť →", de: "Digitale Sicherheit erkunden →", "zh-CN": "探索数字安全 →" },
      href: "/topwallet/seguridad",
    },
    {
      id: "defi",
      numero: "04",
      icono: "⚡",
      badge: { es: "DEFI", en: "DEFI", sk: "DEFI", de: "DEFI", "zh-CN": "DEFI" },
      titulo: { es: "DeFi & Transferencias", en: "DeFi & Transfers", sk: "DeFi & Prevody", de: "DeFi & Transfers", "zh-CN": "DeFi & 转账" },
      descripcion: {
        es: "Tokens, swaps, staking y movimientos on-chain explicados visualmente. La nueva economía sin bancos.",
        en: "Tokens, swaps, staking and on-chain movements visually explained. The new economy without banks.",
        sk: "Tokeny, swapy, staking a on-chain pohyby vizuálne vysvetlené. Nová ekonomika bez bánk.", de: "Token, Swaps, Staking und On-Chain-Bewegungen visuell erklärt. Die neue Wirtschaft ohne Banken.", "zh-CN": "代币、交换、质押和链上操作的可视化讲解。无需银行的新经济。",
      },
      boton: { es: "Explorar DeFi & Transferencias →", en: "Explore DeFi & Transfers →", sk: "Preskúmať DeFi & Prevody →", de: "DeFi & Transfers erkunden →", "zh-CN": "探索 DeFi & 转账 →" },
      href: "/topwallet/defi",
    },
  ],

  comparadorBtn: {
    es: "⚖ Comparador de 35 Wallets →",
    en: "⚖ Compare 35 Wallets →",
    sk: "⚖ Porovnať 35 Peňaženiek →", de: "⚖ Vergleich von 35 Wallets →", "zh-CN": "⚖ 35 款钱包对比工具 →",
  },

  comparadorCard: {
    titulo: {
      es: "Comparador de Wallets",
      en: "Wallet Comparator",
      sk: "Porovnávač Peňaženiek", de: "Wallet-Vergleich", "zh-CN": "钱包对比工具",
    },
    descripcion: {
      es: "Compara, analiza y elige la mejor wallet para ti. Seguridad, facilidad de uso, criptomonedas soportadas, compatibilidad y coste — 35 wallets bajo el mismo radar.",
      en: "Compare, analyze and choose the best wallet for you. Security, ease of use, supported coins, compatibility and cost — 35 wallets under the same radar.",
      sk: "Porovnaj, analyzuj a vyber si najlepšiu peňaženku. Bezpečnosť, jednoduchosť, kryptomeny, kompatibilita a cena — 35 peňaženiek pod jedným radarom.", de: "Vergleiche, analysiere und wähle die beste Wallet für dich. Sicherheit, Benutzerfreundlichkeit, unterstützte Kryptowährungen, Kompatibilität und Kosten — 35 Wallets auf demselben Radar.", "zh-CN": "对比、分析并选择最适合你的钱包。安全性、易用性、支持的加密货币、兼容性和成本 — 35 款钱包全方位评测。",
    },
  },

  volver: {
    es: "← Volver a TopWallet",
    en: "← Back to TopWallet",
    sk: "← Späť na TopWallet", de: "← Zurück zu TopWallet", "zh-CN": "← 返回 TopWallet",
  },

  comparadorCta: {
    es: "⚖ Ver Comparador →",
    en: "⚖ View Comparator →",
    sk: "⚖ Pozrieť Porovnávač →", de: "⚖ Vergleich ansehen →", "zh-CN": "⚖ 查看对比工具 →",
  },

  breadcrumbRoot: {
    es: "TopWallet",
    en: "TopWallet",
    sk: "TopWallet", de: "TopWallet", "zh-CN": "TopWallet",
  },

  conceptosTitle: {
    es: "Conceptos clave",
    en: "Key concepts",
    sk: "Kľúčové pojmy", de: "Schlüsselkonzepte", "zh-CN": "核心概念",
  },

  articulosTitle: {
    es: "Artículos en profundidad",
    en: "In-depth articles",
    sk: "Hĺbkové články", de: "Tiefgehende Artikel", "zh-CN": "深度文章",
  },

  todosArticulos: {
    es: "Ver todos los artículos →",
    en: "View all articles →",
    sk: "Zobraziť všetky články →", de: "Alle Artikel ansehen →", "zh-CN": "查看所有文章 →",
  },

  hubArticulos: {
    pretitulo: {
      es: "BIBLIOTECA TOPWALLET",
      en: "TOPWALLET LIBRARY",
      sk: "KNIŽNICA TOPWALLET", de: "TOPWALLET-BIBLIOTHEK", "zh-CN": "TOPWALLET 知识库",
    },
    titulo: {
      es: "Todos los artículos en un solo lugar",
      en: "All articles in one place",
      sk: "Všetky články na jednom mieste", de: "Alle Artikel an einem Ort", "zh-CN": "所有文章集中在一处",
    },
    subtitulo: {
      es: "14 artículos en profundidad sobre wallets, blockchain, seguridad y DeFi. Filtra por sección o nivel, o busca por palabra clave.",
      en: "14 in-depth articles on wallets, blockchain, security and DeFi. Filter by section or level, or search by keyword.",
      sk: "14 hĺbkových článkov o peňaženkách, blockchaine, bezpečnosti a DeFi. Filtruj podľa sekcie alebo úrovne, alebo hľadaj.", de: "14 tiefgehende Artikel über Wallets, Blockchain, Sicherheit und DeFi. Filtere nach Bereich oder Level oder suche nach Stichwort.", "zh-CN": "14 篇关于钱包、区块链、安全和 DeFi 的深度文章。按板块或难度筛选，或通过关键词搜索。",
    },
    filtroSeccion: {
      es: "Sección",
      en: "Section",
      sk: "Sekcia", de: "Bereich", "zh-CN": "板块",
    },
    filtroNivel: {
      es: "Nivel",
      en: "Level",
      sk: "Úroveň", de: "Level", "zh-CN": "难度",
    },
    todas: { es: "Todas", en: "All", sk: "Všetky", de: "Alle", "zh-CN": "全部" },
    todos: { es: "Todos", en: "All", sk: "Všetky", de: "Alle", "zh-CN": "全部" },
    buscar: {
      es: "Buscar por título o palabra clave…",
      en: "Search by title or keyword…",
      sk: "Hľadať podľa titulu alebo kľúčového slova…", de: "Nach Titel oder Stichwort suchen…", "zh-CN": "按标题或关键词搜索…",
    },
    sinResultados: {
      es: "No hay artículos que coincidan con esos filtros.",
      en: "No articles match those filters.",
      sk: "Žiadne články nezodpovedajú filtrom.", de: "Keine Artikel entsprechen diesen Filtern.", "zh-CN": "没有符合这些筛选条件的文章。",
    },
    contador: {
      es: "artículos",
      en: "articles",
      sk: "článkov", de: "Artikel", "zh-CN": "篇文章",
    },
    contadorSingular: {
      es: "artículo",
      en: "article",
      sk: "článok", de: "Artikel", "zh-CN": "篇文章",
    },
  },

  leerArticulo: {
    es: "Leer artículo →",
    en: "Read article →",
    sk: "Čítať článok →", de: "Artikel lesen →", "zh-CN": "阅读文章 →",
  },

  resumenLabel: {
    es: "Resumen",
    en: "Summary",
    sk: "Zhrnutie", de: "Zusammenfassung", "zh-CN": "摘要",
  },

  puntosClaveLabel: {
    es: "Puntos clave",
    en: "Key takeaways",
    sk: "Kľúčové body", de: "Wichtigste Punkte", "zh-CN": "要点",
  },

  advertenciaLabel: {
    es: "Advertencia",
    en: "Warning",
    sk: "Varovanie", de: "Warnung", "zh-CN": "警告",
  },

  tipLabel: {
    es: "Tip pro",
    en: "Pro tip",
    sk: "Pro tip", de: "Profi-Tipp", "zh-CN": "专业提示",
  },

  volverSeccion: {
    es: "← Volver a la sección",
    en: "← Back to section",
    sk: "← Späť na sekciu", de: "← Zurück zum Bereich", "zh-CN": "← 返回板块",
  },

  nivelBadge: {
    basico: { es: "BÁSICO", en: "BASIC", sk: "ZÁKLADNÉ", de: "GRUNDLAGEN", "zh-CN": "基础" },
    intermedio: { es: "INTERMEDIO", en: "INTERMEDIATE", sk: "STREDNÉ", de: "FORTGESCHRITTEN", "zh-CN": "中级" },
    avanzado: { es: "AVANZADO", en: "ADVANCED", sk: "POKROČILÉ", de: "ERWEITERT", "zh-CN": "高级" },
  },

  secciones: {
    carteras: {
      descripcion: {
        es: "Una wallet NO guarda tus monedas. Guarda las claves privadas que demuestran que eres el propietario. Sin tus claves → sin acceso.",
        en: "A wallet does NOT store your coins. It stores the private keys that prove ownership. Without your keys → no access.",
        sk: "Peňaženka NEUKLADÁ tvoje mince. Ukladá súkromné kľúče, ktoré dokazujú vlastníctvo. Bez kľúčov → žiadny prístup.", de: "Eine Wallet speichert NICHT deine Coins. Sie speichert die Private Keys, die beweisen, dass du der Eigentümer bist. Ohne deine Keys → kein Zugang.", "zh-CN": "钱包不存储你的币。它存储证明你是所有者的私钥。没有私钥 → 无法访问。",
      },
      conceptos: [
        {
          icono: "🔑",
          tipo: "basico",
          titulo: { es: "Clave Privada vs Pública", en: "Private Key vs Public Key", sk: "Súkromný vs Verejný kľúč", de: "Private Key vs Public Key", "zh-CN": "私钥 vs 公钥" },
          descripcion: {
            es: "La clave pública es como tu número de cuenta — puedes compartirla para recibir fondos. La clave privada es como tu PIN — NUNCA la compartas. Quien tiene la clave privada, controla los fondos.",
            en: "The public key is like your account number — share it to receive funds. The private key is like your PIN — NEVER share it. Whoever has the private key controls the funds.",
            sk: "Verejný kľúč je ako číslo účtu — zdieľaj ho na prijímanie. Súkromný kľúč je ako PIN — NIKDY ho nezdieľaj. Kto má súkromný kľúč, kontroluje prostriedky.", de: "Der Public Key ist wie deine Kontonummer — du kannst ihn teilen, um Gelder zu empfangen. Der Private Key ist wie deine PIN — teile ihn NIEMALS. Wer den Private Key hat, kontrolliert die Gelder.", "zh-CN": "公钥就像你的账号 — 可以分享以接收资金。私钥就像你的 PIN — 绝不分享。谁拥有私钥，谁就控制资金。",
          },
        },
        {
          icono: "📝",
          tipo: "basico",
          titulo: { es: "Frase Semilla (Seed Phrase)", en: "Seed Phrase", sk: "Seed Fráza", de: "Seed Phrase", "zh-CN": "助记词（Seed Phrase）" },
          descripcion: {
            es: "12 o 24 palabras que son la copia maestra de tu clave privada. Con ellas puedes recuperar tu wallet en cualquier dispositivo. ESCRÍBELAS EN PAPEL. Nunca digital, nunca foto.",
            en: "12 or 24 words that are the master copy of your private key. With them you can recover your wallet on any device. WRITE THEM ON PAPER. Never digital, never photo.",
            sk: "12 alebo 24 slov — hlavná kópia súkromného kľúča. S nimi obnovíš peňaženku na akomkoľvek zariadení. NAPÍŠ NA PAPIER. Nikdy digitálne, nikdy foto.", de: "12 oder 24 Wörter, die die Masterkopie deines Private Keys sind. Mit ihnen kannst du deine Wallet auf jedem Gerät wiederherstellen. SCHREIBE SIE AUF PAPIER. Niemals digital, niemals als Foto.", "zh-CN": "12 或 24 个单词，是你私钥的主备份。有了它们你可以在任何设备上恢复钱包。用纸写下来。绝不数字化，绝不拍照。",
          },
        },
        {
          icono: "🌡️",
          tipo: "basico",
          titulo: { es: "Hot Wallet vs Cold Wallet", en: "Hot Wallet vs Cold Wallet", sk: "Hot vs Cold Peňaženka", de: "Hot Wallet vs Cold Wallet", "zh-CN": "热钱包 vs 冷钱包" },
          descripcion: {
            es: "Hot wallet = conectada a internet (MetaMask, Trust Wallet). Conveniente pero más vulnerable. Cold wallet = offline (Ledger, Trezor). Las claves nunca tocan internet. Hot para el día a día, cold para tus ahorros.",
            en: "Hot wallet = connected to internet (MetaMask, Trust Wallet). Convenient but more vulnerable. Cold wallet = offline (Ledger, Trezor). Keys never touch internet. Hot for daily use, cold for savings.",
            sk: "Hot = pripojená na internet. Pohodlná, ale zraniteľnejšia. Cold = offline (Ledger, Trezor). Kľúče sa nikdy nedotknú internetu. Hot na každodenné použitie, cold na úspory.", de: "Hot Wallet = mit dem Internet verbunden (MetaMask, Trust Wallet). Bequem aber anfälliger. Cold Wallet = offline (Ledger, Trezor). Die Keys berühren niemals das Internet. Hot für den täglichen Gebrauch, Cold für deine Ersparnisse.", "zh-CN": "热钱包 = 联网（MetaMask、Trust Wallet）。方便但更容易受攻击。冷钱包 = 离线（Ledger、Trezor）。私钥永不接触互联网。日常使用热钱包，储蓄使用冷钱包。",
          },
        },
        {
          icono: "🏦",
          tipo: "intermedio",
          titulo: { es: "Custodial vs Self-Custody", en: "Custodial vs Self-Custody", sk: "Custodial vs Self-Custody", de: "Custodial vs Self-Custody", "zh-CN": "托管 vs 自我托管" },
          descripcion: {
            es: "Custodial: un exchange guarda tus claves (Binance, Coinbase). Fácil pero si quiebran lo pierdes todo (FTX). Self-custody: tú guardas tus propias claves. Más responsabilidad pero TOTAL control.",
            en: "Custodial: an exchange holds your keys. Easy but if they collapse you lose everything (FTX). Self-custody: you hold your own keys. More responsibility but TOTAL control.",
            sk: "Custodial: burza uchováva tvoje kľúče. Jednoduché, ale ak skrachujú, prídeš o všetko (FTX). Self-custody: ty uchovávaš vlastné kľúče. Viac zodpovednosti, ale ÚPLNÁ kontrola.", de: "Custodial: eine Exchange verwahrt deine Keys (Binance, Coinbase). Einfach, aber wenn sie pleitegeht, verlierst du alles (FTX). Self-Custody: du verwahrst deine eigenen Keys. Mehr Verantwortung aber TOTALE Kontrolle.", "zh-CN": "托管：交易所保管你的私钥（Binance、Coinbase）。简单但如果破产你会失去一切（FTX）。自我托管：你自己保管私钥。责任更大但拥有完全控制权。",
          },
        },
      ],
    },
    redes: {
      descripcion: {
        es: "Una blockchain es una base de datos distribuida entre miles de ordenadores que registra transacciones de forma permanente e inmutable. Nadie puede alterarla.",
        en: "A blockchain is a distributed database across thousands of computers that permanently records transactions. No one can alter it.",
        sk: "Blockchain je distribuovaná databáza naprieč tisíckami počítačov, ktorá trvalo zaznamenáva transakcie. Nikto ju nemôže zmeniť.", de: "Eine Blockchain ist eine verteilte Datenbank über Tausende von Computern, die Transaktionen dauerhaft und unveränderlich aufzeichnet. Niemand kann sie ändern.", "zh-CN": "区块链是分布在数千台计算机之间的数据库，永久且不可篡改地记录交易。没人能修改它。",
      },
      conceptos: [
        {
          icono: "📦",
          tipo: "basico",
          titulo: { es: "¿Cómo funciona un bloque?", en: "How does a block work?", sk: "Ako funguje blok?", de: "Wie funktioniert ein Block?", "zh-CN": "区块如何运作？" },
          descripcion: {
            es: "Cada bloque contiene: transacciones, el hash del bloque anterior (que lo encadena) y un timestamp. Los mineros resuelven un puzzle matemático para añadir el siguiente bloque y recibir la recompensa.",
            en: "Each block contains: transactions, the previous block hash and a timestamp. Miners solve a mathematical puzzle to add the next block and receive the reward.",
            sk: "Každý blok obsahuje: transakcie, hash predchádzajúceho bloku a časovú pečiatku. Ťažiari riešia matematickú hádanku, aby pridali ďalší blok a dostali odmenu.", de: "Jeder Block enthält: Transaktionen, den Hash des vorherigen Blocks (der ihn verkettet) und einen Zeitstempel. Miner lösen ein mathematisches Rätsel, um den nächsten Block hinzuzufügen und die Belohnung zu erhalten.", "zh-CN": "每个区块包含：交易、前一个区块的哈希值（将其链接）和时间戳。矿工解决数学难题来添加下一个区块并获得奖励。",
          },
        },
        {
          icono: "⚡",
          tipo: "intermedio",
          titulo: { es: "Proof of Work vs Proof of Stake", en: "Proof of Work vs Proof of Stake", sk: "PoW vs PoS", de: "Proof of Work vs Proof of Stake", "zh-CN": "Proof of Work vs Proof of Stake" },
          descripcion: {
            es: "PoW (Bitcoin): los mineros gastan energía real para validar — extremadamente seguro. PoS (Ethereum, Solana): los validadores bloquean fondos como garantía — más eficiente energéticamente.",
            en: "PoW (Bitcoin): miners spend real energy to validate — extremely secure. PoS (Ethereum, Solana): validators lock funds as collateral — more energy efficient.",
            sk: "PoW (Bitcoin): ťažiari míňajú reálnu energiu — mimoriadne bezpečné. PoS (Ethereum, Solana): validátori blokujú prostriedky — energeticky efektívnejšie.", de: "PoW (Bitcoin): Miner verbrauchen echte Energie zur Validierung — extrem sicher. PoS (Ethereum, Solana): Validatoren sperren Gelder als Sicherheit — energieeffizienter.", "zh-CN": "PoW（比特币）：矿工消耗真实能源来验证 — 极其安全。PoS（以太坊、Solana）：验证者锁定资金作为保证 — 能源效率更高。",
          },
        },
        {
          icono: "🏗️",
          tipo: "intermedio",
          titulo: { es: "Layer 1 vs Layer 2", en: "Layer 1 vs Layer 2", sk: "Layer 1 vs Layer 2", de: "Layer 1 vs Layer 2", "zh-CN": "Layer 1 vs Layer 2" },
          descripcion: {
            es: "Layer 1: la blockchain principal (Bitcoin, Ethereum, Solana). Layer 2: redes construidas encima para escalar velocidad y reducir comisiones. Ejemplos: Lightning Network, Arbitrum, Optimism, Base.",
            en: "Layer 1: the main blockchain (Bitcoin, Ethereum, Solana). Layer 2: networks on top to scale speed and reduce fees. Examples: Lightning Network, Arbitrum, Optimism, Base.",
            sk: "Layer 1: hlavný blockchain. Layer 2: siete na vrch na škálovanie a zníženie poplatkov. Príklady: Lightning Network, Arbitrum, Optimism, Base.", de: "Layer 1: die Haupt-Blockchain (Bitcoin, Ethereum, Solana). Layer 2: Netzwerke, die darauf aufbauen, um Geschwindigkeit zu skalieren und Gebühren zu reduzieren. Beispiele: Lightning Network, Arbitrum, Optimism, Base.", "zh-CN": "Layer 1：主区块链（比特币、以太坊、Solana）。Layer 2：建立在主链之上以提高速度和降低费用的网络。例如：Lightning Network、Arbitrum、Optimism、Base。",
          },
        },
        {
          icono: "⛽",
          tipo: "intermedio",
          titulo: { es: "Gas y Comisiones de Red", en: "Gas and Network Fees", sk: "Gas a Sieťové Poplatky", de: "Gas und Netzwerkgebühren", "zh-CN": "Gas 和网络费用" },
          descripcion: {
            es: "El gas es el coste de operar en la blockchain. Ethereum puede ser $1 en L2 o $50 en L1. Bitcoin cobra por bytes de datos. Solana cobra fracciones de centavo. Siempre ten fondos extra para gas.",
            en: "Gas is the cost of operating on the blockchain. Ethereum can be $1 on L2 or $50 on L1. Bitcoin charges by data bytes. Solana charges fractions of a cent. Always keep extra for gas.",
            sk: "Gas je cena za operácie na blockchaine. Ethereum môže byť $1 na L2 alebo $50 na L1. Bitcoin účtuje podľa bajtov. Solana účtuje zlomky centu.", de: "Gas sind die Kosten für Operationen auf der Blockchain. Ethereum kann $1 auf L2 oder $50 auf L1 sein. Bitcoin berechnet nach Datenbytes. Solana berechnet Bruchteile eines Cents. Habe immer zusätzliche Gelder für Gas.", "zh-CN": "Gas 是在区块链上操作的成本。以太坊在 L2 可能是 $1，在 L1 可能是 $50。比特币按数据字节收费。Solana 收取几美分的零头。始终准备额外的资金用于 gas。",
          },
        },
      ],
    },
    seguridad: {
      descripcion: {
        es: "En cripto TÚ eres el banco. Si pierdes tus claves o te estafan, nadie puede devolverte los fondos. La seguridad es la habilidad más importante de cualquier holder.",
        en: "In crypto YOU are the bank. If you lose your keys or get scammed, no one can return your funds. Security is the most important skill of any holder.",
        sk: "V krypte TY si banka. Ak stratíš kľúče alebo ťa podvedú, nikto ti nevráti prostriedky. Bezpečnosť je najdôležitejšia zručnosť každého holdera.", de: "In Krypto bist DU die Bank. Wenn du deine Keys verlierst oder betrogen wirst, kann niemand dir die Gelder zurückgeben. Sicherheit ist die wichtigste Fähigkeit jedes HODLers.", "zh-CN": "在加密世界你就是银行。如果丢失私钥或被骗，没人能退还你的资金。安全是任何 HODL 者最重要的技能。",
      },
      conceptos: [
        {
          icono: "🥇",
          tipo: "basico",
          titulo: { es: "Las 5 Reglas de Oro", en: "The 5 Golden Rules", sk: "5 Zlatých Pravidiel", de: "Die 5 Goldenen Regeln", "zh-CN": "5 条黄金法则" },
          descripcion: {
            es: "1. NUNCA compartas tu seed phrase. 2. Guárdala OFFLINE en papel. 3. NUNCA la fotografíes. 4. Usa contraseñas únicas y un gestor. 5. Activa 2FA en todos tus exchanges.",
            en: "1. NEVER share your seed phrase. 2. Store it OFFLINE on paper. 3. NEVER photograph it. 4. Use unique passwords and a manager. 5. Enable 2FA on all your exchanges.",
            sk: "1. NIKDY nezdieľaj seed frázu. 2. Uchovaj OFFLINE na papieri. 3. NIKDY nefotografuj. 4. Používaj jedinečné heslá a správcu. 5. Aktivuj 2FA na všetkých burzách.", de: "1. Teile NIEMALS deine Seed Phrase. 2. Bewahre sie OFFLINE auf Papier auf. 3. Fotografiere sie NIEMALS. 4. Verwende einzigartige Passwörter und einen Manager. 5. Aktiviere 2FA auf allen deinen Exchanges.", "zh-CN": "1. 绝不分享助记词。2. 离线用纸保存。3. 绝不拍照。4. 使用唯一密码和密码管理器。5. 在所有交易所启用 2FA。",
          },
        },
        {
          icono: "🎣",
          tipo: "basico",
          titulo: { es: "Cómo detectar un Phishing", en: "How to detect Phishing", sk: "Ako odhaliť Phishing", de: "Wie erkennst du Phishing", "zh-CN": "如何识别钓鱼攻击" },
          descripcion: {
            es: "Señales de alarma: URLs similares pero falsas (metamásk.com vs metamask.io), emails urgentes, pop-ups pidiendo tu seed phrase, soporte técnico que te contacta primero. NINGÚN servicio legítimo te pedirá tu seed phrase.",
            en: "Warning signs: similar but fake URLs, urgent emails, pop-ups asking for your seed phrase, tech support contacting you first. NO legitimate service will ever ask for your seed phrase.",
            sk: "Varovné signály: podobné ale falošné URL, urgentné e-maily, pop-upy žiadajúce seed frázu, technická podpora, ktorá ťa kontaktuje ako prvá. ŽIADNA legitímna služba nepožiada o seed frázu.", de: "Warnzeichen: ähnliche aber falsche URLs (metamásk.com vs metamask.io), dringende E-Mails, Pop-ups, die nach deiner Seed Phrase fragen, technischer Support, der dich zuerst kontaktiert. KEIN legitimer Service wird nach deiner Seed Phrase fragen.", "zh-CN": "警告信号：相似但虚假的网址（metamásk.com vs metamask.io）、紧急邮件、要求助记词的弹窗、主动联系你的技术支持。任何合法服务都不会要求你的助记词。",
          },
        },
        {
          icono: "🔷",
          tipo: "intermedio",
          titulo: { es: "Hardware Wallet: Cómo funciona", en: "Hardware Wallet: How it works", sk: "Hardvérová Peňaženka", de: "Hardware Wallet: Wie es funktioniert", "zh-CN": "硬件钱包：工作原理" },
          descripcion: {
            es: "Guarda tus claves privadas en un chip seguro aislado. Cuando firmas una transacción, la firma ocurre DENTRO del dispositivo — la clave privada NUNCA sale. Aunque tu PC tenga virus, tus fondos están a salvo.",
            en: "Stores your private keys in an isolated secure chip. When you sign a transaction, signing happens INSIDE the device — the private key NEVER leaves. Even with a virus on your PC, your funds are safe.",
            sk: "Uchováva kľúče v izolovanom čipe. Podpisovanie prebieha VNÚTRI zariadenia — kľúč NIKDY nevychádza. Aj s vírusom na PC sú prostriedky v bezpečí.", de: "Speichert deine Private Keys in einem isolierten sicheren Chip. Wenn du eine Transaktion signierst, erfolgt die Signatur INNERHALB des Geräts — der Private Key verlässt es NIEMALS. Selbst wenn dein PC einen Virus hat, sind deine Gelder sicher.", "zh-CN": "将私钥存储在隔离的安全芯片中。签署交易时，签名在设备内部完成 — 私钥永不离开。即使你的电脑有病毒，资金也是安全的。",
          },
        },
        {
          icono: "✍️",
          tipo: "avanzado",
          titulo: { es: "Multi-Signature (Multisig)", en: "Multi-Signature (Multisig)", sk: "Multisig", de: "Multi-Signature (Multisig)", "zh-CN": "多重签名（Multisig）" },
          descripcion: {
            es: "Requiere múltiples firmas para aprobar una transacción (ej: 2 de 3 claves). Usada por empresas y grandes holders. Si una clave se compromete, los fondos siguen seguros. Gnosis Safe es el estándar en Ethereum.",
            en: "Requires multiple signatures to approve a transaction (e.g.: 2 of 3 keys). Used by companies and large holders. If one key is compromised, funds remain safe. Gnosis Safe is the Ethereum standard.",
            sk: "Vyžaduje viacero podpisov (napr.: 2 z 3 kľúčov). Ak je jeden kľúč kompromitovaný, prostriedky zostávajú v bezpečí. Gnosis Safe je štandard na Ethereum.", de: "Erfordert mehrere Signaturen zur Genehmigung einer Transaktion (z.B.: 2 von 3 Keys). Wird von Unternehmen und großen HODLern verwendet. Wenn ein Key kompromittiert wird, sind die Gelder weiterhin sicher. Gnosis Safe ist der Standard auf Ethereum.", "zh-CN": "需要多个签名才能批准交易（例如：3 个密钥中的 2 个）。企业和大户使用。如果一个密钥被泄露，资金仍然安全。Gnosis Safe 是以太坊的标准。",
          },
        },
      ],
    },
    defi: {
      descripcion: {
        es: "DeFi son aplicaciones financieras que operan automáticamente mediante contratos inteligentes, sin bancos ni intermediarios. Cualquiera con una wallet puede acceder.",
        en: "DeFi is financial applications that operate automatically through smart contracts, without banks or intermediaries. Anyone with a wallet can access.",
        sk: "DeFi sú finančné aplikácie fungujúce automaticky cez smart kontrakty, bez bánk. Ktokoľvek s peňaženkou môže pristupovať.", de: "DeFi sind Finanzanwendungen, die automatisch über Smart Contracts laufen, ohne Banken oder Intermediäre. Jeder mit einer Wallet kann darauf zugreifen.", "zh-CN": "DeFi 是通过智能合约自动运行的金融应用，无需银行或中介。任何有钱包的人都可以访问。",
      },
      conceptos: [
        {
          icono: "🔄",
          tipo: "basico",
          titulo: { es: "¿Qué es un Swap?", en: "What is a Swap?", sk: "Čo je Swap?", de: "Was ist ein Swap?", "zh-CN": "什么是 Swap？" },
          descripcion: {
            es: "Intercambiar un token por otro on-chain sin exchange centralizado. Un DEX como Uniswap calcula el precio automáticamente con la fórmula x*y=k. Pagas gas + comisión del pool (0.05-1%). Sin KYC ni cuenta.",
            en: "Exchange one token for another on-chain without a centralized exchange. A DEX like Uniswap calculates price automatically with x*y=k. You pay gas + pool fee (0.05-1%). No KYC, no account.",
            sk: "Výmena tokenu za iný on-chain bez centralizovanej burzy. DEX ako Uniswap vypočíta cenu pomocou x*y=k. Platíš gas + poplatok poolu (0,05-1%). Bez KYC, bez účtu.", de: "Einen Token gegen einen anderen On-Chain tauschen, ohne zentralisierte Exchange. Ein DEX wie Uniswap berechnet den Preis automatisch mit der Formel x*y=k. Du zahlst Gas + Pool-Gebühr (0,05-1%). Ohne KYC oder Konto.", "zh-CN": "在链上直接交换一种代币到另一种，无需中心化交易所。Uniswap 等 DEX 使用 x*y=k 公式自动计算价格。支付 gas + 流动性池费用（0.05-1%）。无需 KYC 或账户。",
          },
        },
        {
          icono: "🌱",
          tipo: "intermedio",
          titulo: { es: "Staking: Gana por tener", en: "Staking: Earn by holding", sk: "Staking: Zarábaj držaním", de: "Staking: Verdiene durch Halten", "zh-CN": "质押：持有即赚取" },
          descripcion: {
            es: "Bloquear tokens en un protocolo para recibir recompensas. Los validadores PoS hacen staking para participar en el consenso. APY típico: 3-7% en ETH nativo, hasta 20%+ en DeFi (mayor riesgo).",
            en: "Lock tokens in a protocol to receive rewards. PoS validators stake to participate in consensus. Typical APY: 3-7% on native ETH, up to 20%+ on DeFi (higher risk).",
            sk: "Uzamknutie tokenov na získanie odmien. Validátori stakujú na konsenzus. Typické APY: 3-7% na natívnom ETH, až 20%+ na DeFi (vyššie riziko).", de: "Token in einem Protokoll sperren, um Belohnungen zu erhalten. PoS-Validatoren machen Staking, um am Konsens teilzunehmen. Typische APY: 3-7% bei nativem ETH, bis 20%+ in DeFi (höheres Risiko).", "zh-CN": "锁定代币到协议中以获得奖励。PoS 验证者通过质押参与共识。典型 APY：ETH 原生 3-7%，DeFi 高达 20%+（风险更高）。",
          },
        },
        {
          icono: "🌉",
          tipo: "intermedio",
          titulo: { es: "Bridges: Mover fondos entre redes", en: "Bridges: Move funds between networks", sk: "Bridges: Presun medzi sieťami", de: "Bridges: Gelder zwischen Netzwerken verschieben", "zh-CN": "跨链桥：在网络间转移资金" },
          descripcion: {
            es: "Enviar activos de una blockchain a otra. Son uno de los vectores de hackeo más comunes — usa solo bridges auditados: Stargate, Across o el bridge oficial de la red.",
            en: "Send assets from one blockchain to another. They are one of the most common hack vectors — use only audited bridges: Stargate, Across or the network official bridge.",
            sk: "Presun aktív z jedného blockchainu do druhého. Jeden z najčastejších vektorov hacknutia — používaj len auditované bridges: Stargate, Across alebo oficiálny bridge siete.", de: "Assets von einer Blockchain zur anderen senden. Sie sind einer der häufigsten Hacking-Vektoren — verwende nur auditierte Bridges: Stargate, Across oder die offizielle Bridge des Netzwerks.", "zh-CN": "将资产从一个区块链发送到另一个。这是最常见的黑客攻击载体之一 — 只使用经过审计的桥：Stargate、Across 或网络官方桥。",
          },
        },
        {
          icono: "📜",
          tipo: "avanzado",
          titulo: { es: "Smart Contracts: El código es la ley", en: "Smart Contracts: Code is law", sk: "Smart Kontrakty: Kód je zákon", de: "Smart Contracts: Code ist Gesetz", "zh-CN": "智能合约：代码即法律" },
          descripcion: {
            es: "Programas que se ejecutan automáticamente cuando se cumplen condiciones. Inmutables una vez desplegados. Eliminan intermediarios en préstamos, seguros, exchanges y cualquier acuerdo financiero.",
            en: "Programs that automatically execute when conditions are met. Immutable once deployed. They eliminate intermediaries in loans, insurance, exchanges and any financial agreement.",
            sk: "Programy, ktoré sa automaticky vykonávajú po splnení podmienok. Nemenné po nasadení. Eliminujú sprostredkovateľov pri pôžičkách, poistení, burzách a finančných dohodách.", de: "Programme, die automatisch ausgeführt werden, wenn Bedingungen erfüllt sind. Unveränderlich, sobald sie deployed sind. Eliminieren Intermediäre bei Krediten, Versicherungen, Exchanges und jeder Finanzvereinbarung.", "zh-CN": "满足条件时自动执行的程序。部署后不可更改。在贷款、保险、交易所和任何金融协议中消除中介。",
          },
        },
      ],
    },
  },
};

const PICK = (obj, lang) => (obj && (obj[lang] || obj.en || obj.es)) || "";

export const getTopWalletI18n = (lang) => {
  const L = ["es", "en", "sk", "de", "zh-CN"].includes(lang) ? lang : "en";
  return {
    lang: L,
    pick: (obj) => PICK(obj, L),
    cards: I18N_TW.cards.map((c) => ({
      id: c.id,
      numero: c.numero,
      icono: c.icono,
      badge: PICK(c.badge, L),
      titulo: PICK(c.titulo, L),
      descripcion: PICK(c.descripcion, L),
      boton: PICK(c.boton, L),
      href: c.href,
    })),
    comparadorBtn: PICK(I18N_TW.comparadorBtn, L),
    comparadorCard: {
      titulo: PICK(I18N_TW.comparadorCard.titulo, L),
      descripcion: PICK(I18N_TW.comparadorCard.descripcion, L),
    },
    volver: PICK(I18N_TW.volver, L),
    comparadorCta: PICK(I18N_TW.comparadorCta, L),
    breadcrumbRoot: PICK(I18N_TW.breadcrumbRoot, L),
    conceptosTitle: PICK(I18N_TW.conceptosTitle, L),
    articulosTitle: PICK(I18N_TW.articulosTitle, L),
    todosArticulos: PICK(I18N_TW.todosArticulos, L),
    hubArticulos: {
      pretitulo: PICK(I18N_TW.hubArticulos.pretitulo, L),
      titulo: PICK(I18N_TW.hubArticulos.titulo, L),
      subtitulo: PICK(I18N_TW.hubArticulos.subtitulo, L),
      filtroSeccion: PICK(I18N_TW.hubArticulos.filtroSeccion, L),
      filtroNivel: PICK(I18N_TW.hubArticulos.filtroNivel, L),
      todas: PICK(I18N_TW.hubArticulos.todas, L),
      todos: PICK(I18N_TW.hubArticulos.todos, L),
      buscar: PICK(I18N_TW.hubArticulos.buscar, L),
      sinResultados: PICK(I18N_TW.hubArticulos.sinResultados, L),
      contador: PICK(I18N_TW.hubArticulos.contador, L),
      contadorSingular: PICK(I18N_TW.hubArticulos.contadorSingular, L),
    },
    leerArticulo: PICK(I18N_TW.leerArticulo, L),
    resumenLabel: PICK(I18N_TW.resumenLabel, L),
    puntosClaveLabel: PICK(I18N_TW.puntosClaveLabel, L),
    advertenciaLabel: PICK(I18N_TW.advertenciaLabel, L),
    tipLabel: PICK(I18N_TW.tipLabel, L),
    volverSeccion: PICK(I18N_TW.volverSeccion, L),
    nivelBadge: {
      basico: PICK(I18N_TW.nivelBadge.basico, L),
      intermedio: PICK(I18N_TW.nivelBadge.intermedio, L),
      avanzado: PICK(I18N_TW.nivelBadge.avanzado, L),
    },
    seccion: (id) => {
      const s = I18N_TW.secciones[id];
      if (!s) return null;
      return {
        descripcion: PICK(s.descripcion, L),
        conceptos: s.conceptos.map((c) => ({
          icono: c.icono,
          tipo: c.tipo,
          titulo: PICK(c.titulo, L),
          descripcion: PICK(c.descripcion, L),
        })),
      };
    },
  };
};
